export default __webpack_public_path__ + "img/factory.c0a5da8e.png";